import { api } from './api';
import type { ItemLedgerResponse, ItemLedgerFilters, ItemStockSnapshot } from '../types';

function downloadBlob(blobData: BlobPart, mimeType: string, filename: string) {
  const blob = new Blob([blobData], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

/** Strips empty values so the query string only carries active filters. */
function toParams(filters: ItemLedgerFilters = {}) {
  return Object.fromEntries(
    Object.entries(filters).filter(([, value]) => value !== undefined && value !== '' && value !== null)
  );
}

export const itemLedgerApi = {
  getLedger: async (itemId: string, filters: ItemLedgerFilters = {}): Promise<ItemLedgerResponse> => {
    const response = await api.get(`/items/${itemId}/ledger`, { params: toParams(filters) });
    return response.data.data;
  },

  getStockSnapshot: async (itemId: string): Promise<ItemStockSnapshot> => {
    const response = await api.get(`/items/${itemId}/stock-snapshot`);
    return response.data.data;
  },

  downloadExcel: async (itemId: string, itemCode: string, filters: ItemLedgerFilters = {}): Promise<void> => {
    const response = await api.get(`/items/${itemId}/ledger/export/excel`, {
      params: toParams(filters),
      responseType: 'blob',
    });
    downloadBlob(
      response.data,
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      `${itemCode || 'item'}-history.xlsx`
    );
  },

  downloadCsv: async (itemId: string, itemCode: string, filters: ItemLedgerFilters = {}): Promise<void> => {
    const response = await api.get(`/items/${itemId}/ledger/export/csv`, {
      params: toParams(filters),
      responseType: 'blob',
    });
    downloadBlob(response.data, 'text/csv', `${itemCode || 'item'}-history.csv`);
  },
};
